var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import styled, { css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
var widthSizes = {
  large: 8,
  medium: 6,
  small: 4
};
var fullScreenStyles = css(["width:100vw;height:100vh;"]);
var fullContainerStyles = css(["width:", "px;height:calc(100% - 64px);margin:0 auto;box-sizing:border-box;"], grid(10));
export var ModalContent = styled.div.withConfig({
  displayName: "ModalContent",
  componentId: "sc-5hi519-0"
})(["position:relative;margin:auto;width:", " ", " ", " max-width:100%;border-radius:", ";box-shadow:", ";background-color:", ";", ";", ";"], function (_ref) {
  var _ref$widthSize = _ref.widthSize,
    widthSize = _ref$widthSize === void 0 ? 'large' : _ref$widthSize;
  return "".concat(grid(widthSizes[widthSize]), "px;");
}, function (_ref2) {
  var variant = _ref2.variant;
  return ['fullScreen'].includes(variant) && fullScreenStyles;
}, function (_ref3) {
  var variant = _ref3.variant;
  return ['fullContainer'].includes(variant) && fullContainerStyles;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.boxShadow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.background;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-radius: 0;\n    min-height: 100%;\n  "]))), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 100%;\n  "]))));